<nb-card>
    <div
        class="ranking-classif"
        *ngFor="let enroll of enrollments | slice : (page - 1) * perPage : (page - 1) * perPage + perPage"
    >
        <div class="ranking-player-classif">
            <span>{{ enroll.posicao_ranking ? enroll.posicao_ranking + "º" : "-" }}</span>
        </div>

        <div class="ranking-info-1">
            <div [ngClass]="{ 'ranking-players': true, 'ranking-players-double': enroll?.parts?.length > 1 }">
                <div
                    *ngFor="let player of enroll.parts"
                    [ngClass]="{ 'ranking-player': true, 'ranking-player-double': enroll?.parts?.length > 1 }"
                >
                    <div class="ranking-image">
                        <img [src]="player.avatar" width="60px" />
                    </div>
                    <div>
                        <!-- prettier-ignore -->
                        <span class="d-block player-name"><strong>{{ player.nome_abreviado }}</strong></span>
                        <span class="d-block player-location">{{ player.cidade }} / {{ player.uf }} </span>
                        <span class="player-age">{{ player.idade }} anos</span>
                    </div>
                    <app-wtn-point
                        [point]="player.wtn?.single ? player.wtn?.single?.format : player.wtn?.double?.format"
                        [tooltip]="player.wtn.single ? player.wtn.single?.title : player.wtn.double?.title"
                        *ngIf="player.wtn"
                        class="ml-3"
                    ></app-wtn-point>
                </div>
            </div>
            <div class="ranking-info">
                <span [ngClass]="['badge', 'badge-' + enroll.situacao.toLowerCase().replace(' ', '-')]">{{
                    enroll.situacao
                }}</span>
            </div>
        </div>
    </div>
    <app-shared-pagination
        [perPage]="perPage"
        [size]="enrollments.length"
        (onChange)="page = $event"
        *ngIf="enrollments"
    ></app-shared-pagination>

    <ng-container *ngIf="!enrollments">
        <h2 class="not-found">
            Ops!
            <br />
            <span>{{ "MESSAGE.RESULT.TRANSACTION-WITHOUT-RETURN" | translate }}</span>
        </h2>
    </ng-container>
</nb-card>
